import React, { useState, useEffect } from "react";
import Footerstyles from "../Comman.module.css";
import { FiPhoneCall } from "react-icons/fi";
import { Link, NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Contactform from "./Contactform";
import { getfootercontact } from "../../../Services/APIrequests"; // adjust the path

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contacts, setContacts] = useState([]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await getfootercontact();
        if (response?.data?.success && response.data.contacts?.length > 0) {
          setContacts(response.data.contacts);
        }
      } catch (error) {
        console.error("Error fetching contact info:", error);
      }
    };

    fetchContacts();
  }, []);

  return (
    <div className={Footerstyles.footer_container}>
      <div className={Footerstyles.footermain_container}>
        {/* Company Info */}
        <div className={Footerstyles.foot_container}>
          <h4 className={Footerstyles.h4text}>
            KOHERE CONNECT PRIVATE LIMITED
          </h4>
          <p className={Footerstyles.ptext}>
            Customize your requirement with our one to one meeting. 
           
          </p>
             <button
          type="button"
          className={Footerstyles.modalbtn}
          onClick={toggleModal}
        >
          Contact us
        </button>
        </div>

        {/* Articles */}
        {/* <div className={Footerstyles.foot_container}>
          <h4 className={Footerstyles.h4text}>Latest Articles</h4>
          <div className={Footerstyles.body_textconatiner}>
            <p className={Footerstyles.ptext}>Blog1</p>
            <p className={Footerstyles.ptext}>Blog2</p>
            <p className={Footerstyles.ptext}>Blog3</p>
            <p className={Footerstyles.ptext}>Blog4</p>
            <p className={Footerstyles.ptext}>Blog5</p>
          </div>
        </div> */}

        <div className={Footerstyles.foot_container}>
          <h4 className={Footerstyles.h4text}>Contact Us</h4>

          {/* Phone Numbers */}
          <div className={Footerstyles.contact1}>
            <h6 className={Footerstyles.h6text}>Phone :</h6>
            {contacts.length > 0 &&
              contacts[0].mobileNumber.map((number, index) => (
                <p key={index} className={Footerstyles.ptext}>
                  {number}
                </p>
              ))}
          </div>
        </div>

        <div className={Footerstyles.foot_container}>
          <h4 className={Footerstyles.h4text}></h4>
          <div className={Footerstyles.body_textconatiner}>
            {/* Emails */}
            <div className={Footerstyles.contact1}>
              <h6 className={Footerstyles.h6text}>Email :</h6>
              {contacts.length > 0 &&
                contacts[0].email.map((email, index) => (
                  <p key={index} className={Footerstyles.ptext}>
                    {email}
                  </p>
                ))}
            </div>
          </div>
        </div>

        {/* Contact Section - Dynamic */}
        {/* Contact Section - Dynamic */}

        {/* Resources */}
        <div className={Footerstyles.foot_container}>
          <h4 className={Footerstyles.h4text}>Resources</h4>
          <div className={Footerstyles.body_textconatiner}>
            <ul className={Footerstyles.Footer_navitems}>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/blog">Blog</NavLink>
              </li>
              <li>
                {/* <NavLink to="#">Testimonials</NavLink> */}

                 <HashLink smooth to="/#Testimonials">
                  Testimonials
                </HashLink>
              </li>
              <li>
                <HashLink smooth to="/#faqs">
                  FAQs
                </HashLink>
              </li>
              <li>
                <NavLink to="/contactus">Contact Us</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Policy Links */}
      <div className={Footerstyles.footer2}>
        <Link to="/Privacypolicy" className={Footerstyles.footer2_link}>
          <p>Privacy Policy</p>
        </Link>
        <Link to="/Terms_Conditions" className={Footerstyles.footer2_link}>
          <p>Terms and Conditions</p>
        </Link>
        <Link to="/refundPolicy" className={Footerstyles.footer2_link}>
          <p>Refund</p>
        </Link>
        <Link to="/cancellationPolicy" className={Footerstyles.footer2_link}>
          <p>Cancellation Policy</p>
        </Link>
      </div>

      {/* Footer CTA */}
      <div className={Footerstyles.footer_contact}>
        <h1 className={Footerstyles.modaltext}>
          Connect with our advisors for further assistance.
        </h1>
        <button
          type="button"
          className={Footerstyles.modalbtn}
          onClick={toggleModal}
        >
          Contact us
        </button>

        <div className={Footerstyles.celltext}>
          <p className={Footerstyles.mtext}>Make a call</p>
          <p className={Footerstyles.mtext}>
            {contacts.length > 0 && contacts[0].mobileNumber.length > 0
              ? contacts[0].mobileNumber[0]
              : "-"}
          </p>
        </div>
      </div>

      {isModalOpen && <Contactform closeModal={toggleModal} />}
    </div>
  );
};

export default Footer;
